import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import _ from 'lodash'
export async function exportToExcelList(list, columns, props = {}) {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(props.nomePlanilha || 'Planilha 1');

    createTable(worksheet, list, columns, props)
    if (props.views) {

        worksheet.views = props.views;
    }
    if (props.autoFilter) {
        worksheet.autoFilter = props.autoFilter
       
    }

    // Cria o buffer
    const buffer = await workbook.xlsx.writeBuffer();

    // Salva como arquivo
    const blob = new Blob([buffer], {
        type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const nomeArquivo = sanitizeFileName(props.nomeArquivo || 'exportacao');
    saveAs(blob, nomeArquivo + ".xlsx");
}

function sanitizeFileName(name) {
    return name
        .replace(/[\\/:*?"<>|]/g, '') // remove caracteres inválidos
        .replace(/\s+/g, '_')         // substitui espaços por underscores (opcional)
        .trim();                      // remove espaços extras
}
function createTable(worksheet, list, columns, props = {}) {
    const { configHeader } = props;

    const colMap = columns.map((c, i) => {
        const col = {
            header: c.labelCol,
        };

        if (typeof c.getValue === 'function') {
            col.key = `__col_${i}`;
            col._getter = c.getValue;
        } else {
            col.key = c.getValue;
        }

        if (c.width) {
            col.width = c.width;
            col._manualWidth = true;
        }

        return col;
    });

    worksheet.columns = colMap;

    list.forEach((item) => {
        const rowData = {};
        colMap.forEach((col) => {
            try {
                rowData[col.key] = col._getter
                    ? col._getter(item)
                    : _.get(item, col.key);
            } catch (err) {
                rowData[col.key] = '';
            }
        });
        // worksheet.addRow(rowData);
        worksheet.addRow(rowData).eachCell((cell) => {
            if (typeof cell.value === 'string' && cell.value.includes('\n')) {
                cell.alignment = { wrapText: true };
            }
        });
    });

    // Estiliza o cabeçalho usando função externa
    const headerRow = worksheet.getRow(1);

    estilizarCabecalhoRow(headerRow, configHeader?.estiloCabecalho);
    ajustarLarguraColunas(worksheet, colMap, configHeader?.maxWidthColumn || 100);
}

function ajustarLarguraColunas(worksheet, colMap, maxWidthPadrao = 100) {
    worksheet.columns.forEach((column, i) => {
        if (colMap[i]._manualWidth) return;

        let colLength = 10;

        column.eachCell({ includeEmpty: true }, (cell) => {
            const cellValue = cell.value ? cell.value.toString() : '';
            colLength = Math.max(colLength, cellValue.length);
        });

        const larguraFinal = Math.min(colLength * 1.2, maxWidthPadrao);
        column.width = larguraFinal;
    });
}

function estilizarCabecalhoRow(row, config = {}) {
    row.eachCell((cell) => {
        cell.font = config.font || { bold: true, color: { argb: 'FFFFFFFF' } };
        cell.fill = config.fill || {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FF0070C0' },
        };
        cell.alignment = config.alignment || { vertical: 'middle', horizontal: 'center' };
        cell.border = config.border || {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },
        };
    });
}

